export default "__VITE_ASSET__1cc5de4f__"